import { Center, Spinner } from "@chakra-ui/react";

export default function CommonSpinner({
  h = "140px",
  w = "140px",
  thickness = "8px",
}: any): JSX.Element {
  return (
    <Center pb={6}>
      <Spinner
        h={h}
        thickness={thickness}
        color="teal.500"
        speed="0.65s"
        w={w}
      />
    </Center>
  );
}
